var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsume({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1731900874418,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 8598,
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 797.11L106.13 611.036c-17.335-4.973-38.912-17.261-66.413-32.914a36.571 36.571 0 1 1 36.205-63.488c12.142 6.876 26.697 14.19 38.035 19.602L512 716.727l379.392-173.86 33.207-16.604 25.38-12.58a36.571 36.571 0 1 1 32.549 65.462l-25.307 12.58a1446.034 1446.034 0 0 1-36.352 17.848v0.073L512 797.11z",
    fill: "#040000",
    "p-id": 8599
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 1009.006L105.326 822.565c-13.24-4.389-33.06-13.97-65.61-32.549a36.571 36.571 0 0 1 36.206-63.634c12.58 7.168 27.795 14.701 39.351 20.187L512 928.55l379.392-173.934 33.207-16.604 25.38-12.58a36.571 36.571 0 1 1 32.549 65.463l-25.307 12.653a1446.034 1446.034 0 0 1-36.352 17.847v0.073L512 1009.006z m-0.731-435.347c-21.358 0-40.156-7.46-57.271-15.506L69.266 386.194a81.554 81.554 0 0 1-43.959-70.729c-1.316-32.183 13.678-62.318 39.132-78.628L452.535 32.84c49.298-24.576 80.164-23.332 121.198 0.878l383.853 201.508c26.697 14.629 42.277 44.69 41.18 78.922-1.097 32.548-17.481 60.123-42.789 71.826l-385.902 172.47c-21.211 9.217-39.058 15.214-58.806 15.214z m3.072-484.864c-6.803 0-15.872 2.926-28.526 9.216L101.157 300.105a23.333 23.333 0 0 0-2.78 12.434c0.146 4.316 1.61 7.315 2.926 7.973l383.122 171.227c27.94 13.02 28.087 11.996 56.174-0.219l385.024-172.105c1.17-2.706 0.658-16.457-2.999-19.895L538.185 97.646c-13.604-7.973-19.822-8.85-23.844-8.85z",
    fill: "#040000",
    "p-id": 8600
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsume);
export default __webpack_public_path__ + "static/media/consume.093eb948c77611b16fe3e294843d7830.svg";
export { ForwardRef as ReactComponent };